import React from "react"
import Button from "components/shared/button/text-button"
import { toMoney, CapAmount } from "utils/string_utils"

export const HorizontalPlanPriceBox = ({
  costs,
  relativePrice,
  relativeOOC,
  data,
  storeName,
  pageToShowEntertainment,
  benefits,
  onSelectPlan,
  id
}) => {
  let totalOOC = costs.ooc + costs.maf
  if (costs.oocCap && !data.ignoreOOCCap) {
    totalOOC = CapAmount(totalOOC, costs.oocCap)
  }

  return (
    <div className="plan-block hplan--price-box">
      <div className="hplan--price-box--details">
        <div className="hplan--price-box--monthly-amount">
          <p className="hplan--price-box--monthly-amount">
            {relativePrice ? (
              <>
                <span className="hplan--price-box--monthly-amount--amount">
                  {relativePrice}
                </span>{" "}
              </>
            ) : (
              <>
                <span className="hplan--price-box--monthly-amount--amount">
                  {toMoney(costs.maf)}
                </span>{" "}
                a month
              </>
            )}
          </p>
        </div>
        <div>{data.lineRental}</div>
        <div className="hplan--price-box--duration">
          {data.contractLength} month{" "}
          {storeName === "Sky" && <span>airtime</span>} plan
        </div>
        {costs.upfront !== undefined && (
          <div className="hplan--price-box--details--upfront-amount">
            {toMoney(costs.upfront || 0)}{" "}
            {/* HACK --- BT wants P&P instead of upfront if upfront cost equals 9.99*/}
            {(storeName === "BT_Acquisition_FTTC" && costs.upfront === 9.99) ||
            (storeName === "BT_Acquisition_FTTP" && costs.upfront === 9.99)
              ? "P&P"
              : "upfront"}
          </div>
        )}

        {/* {!!costs.afterInitialCosts && (
        <div className="hplan--initial-contracts">
          {toMoney(costs.afterInitialCosts)} after initial contract
        </div>
      )} */}
        {/* Currently removed ooc logic until bt sign off */}
        {relativeOOC ? (
          <div className="hplan--price-box--details--upfront-amount ooc">
            {relativeOOC} after initial contract
          </div>
        ) : typeof costs.ooc === "number" ? (
          <div className="hplan--price-box--details--upfront-amount ooc">
            {toMoney(totalOOC)} after initial contract
          </div>
        ) : (
          typeof costs.ooc === "string" && (
            <div className="hplan--price-box--details--upfront-amount ooc">
              {costs.ooc}
            </div>
          )
        )}
      </div>

      <div className="hplan--vertical-button">
        <Button
          text="Select"
          onClick={() => {
            if (
              pageToShowEntertainment === "new" &&
              !("ENTERTAINMENT_PROVIDERS" in benefits) &&
              !("SIMO_ENTERTAINMENT_PROVIDERS" in benefits)
            ) {
              onSelectPlan(id, true)
            } else {
              onSelectPlan(id)
            }
          }}
        />
      </div>
    </div>
  )
}

export default HorizontalPlanPriceBox
